export const createShadows = () => {
	return [
		'none',
		'0px 1px 2px rgba(0, 0, 0, 0.24)',
		'0px 1px 2px rgba(0, 0, 0, 0.24)',
		'0px 1px 4px rgba(0, 0, 0, 0.24)',
		'0px 1px 5px rgba(0, 0, 0, 0.24)',
		'0px 1px 6px rgba(0, 0, 0, 0.24)',
		'0px 2px 6px rgba(0, 0, 0, 0.24)',
		'0px 3px 6px rgba(0, 0, 0, 0.24)',
		'0px 4px 6px rgba(0, 0, 0, 0.24)',
		'0px 5px 12px rgba(0, 0, 0, 0.24)',
		'0px 5px 14px rgba(0, 0, 0, 0.24)',
		'0px 5px 15px rgba(0, 0, 0, 0.24)',
		'0px 6px 15px rgba(0, 0, 0, 0.24)',
		'0px 7px 15px rgba(0, 0, 0, 0.24)',
		'0px 8px 15px rgba(0, 0, 0, 0.24)',
		'0px 9px 15px rgba(0, 0, 0, 0.24)',
		'0px 10px 15px rgba(0, 0, 0, 0.24)',
		'0px 12px 22px rgba(0, 0, 0, 0.24)',
		'0px 13px 22px rgba(0, 0, 0, 0.24)',
		'0px 14px 24px rgba(0, 0, 0, 0.24)',
		'0px 20px 25px rgba(0, 0, 0, 0.24)',
		'0px 25px 50px rgba(0, 0, 0, 0.24)',
		'0px 25px 50px rgba(0, 0, 0, 0.24)',
		'0px 25px 50px rgba(0, 0, 0, 0.24)',
		'0px 25px 50px rgba(0, 0, 0, 0.24)',
	]
}
